<template>
  <base-page-template>
    <v-container fluid>
      <v-card outlined class="elevation-0">
        <v-card-title>
          サービス
          <v-spacer></v-spacer>
          <v-chip
              label dark color="gray darken-4" class="ml-3 px-4"
              v-if="tradeContract.isSelfConsume">
            利用
          </v-chip>
          <v-chip
              label dark color="gray darken-4" class="ml-3 px-4"
              v-if="tradeContract.isSelfProduce">
            提供
          </v-chip>
        </v-card-title>
        <v-card-subtitle>
          <template v-if="tradeContract.selfDataProfileId">
            契約に使用するサービスを選択して下さい
          </template>
          <template v-else>
            <error-icon level="error" small></error-icon>
            はじめにデータステップでマッピングさせるデータプロファイルを選択して下さい。
          </template>
        </v-card-subtitle>
        <v-card-text>
          <v-stepper
              v-model="stepper"
              flat
              vertical>

            <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               Step 1 サービス実装
             - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
            <v-stepper-step step="1" :complete="!!tradeContract.selfServiceProfileId">
              サービス実装の選択
            </v-stepper-step>
            <div v-if="stepper !== 1" class="v-stepper__content">
              <el-table
                  :data="selfServiceProfile ? [selfServiceProfile] : []"
                  row-key="id"
                  border>
                <el-table-column
                    label="名称"
                    width="200"
                    prop="localServiceComponentModel.name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localServiceComponentModel.name"
                          :value-local-id="row.serviceImplementation.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                    label="説明"
                    prop="localServiceComponentModel.description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localServiceComponentModel.description"
                          placeholder="未設定"
                          multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                      justify="center"
                      class="pa-10"
                      v-if="serviceProfilesLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>
            </div>
            <v-stepper-content step="1">
              <el-table
                  :data="serviceProfiles"
                  row-key="id"
                  border>
                <el-table-column
                    label="選択"
                    column-key="selected"
                    width="70"
                    align="center">
                  <template #default="{row}">
                    <table-inline>
                      <el-radio
                          :value="tradeContract.selfServiceProfileId === row.id"
                          @change="tradeContract.selfServiceProfileId = row.id"
                          :label="true"
                          class="no-label"
                          v-if="editable">
                      </el-radio>
                      <readonly-checkbox
                          :value="tradeContract.selfServiceProfileId === row.id"
                          v-else>
                      </readonly-checkbox>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                    label="名称"
                    width="200"
                    prop="localServiceComponentModel.name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localServiceComponentModel.name"
                          :value-local-id="row.serviceImplementation.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                    label="説明"
                    prop="localServiceComponentModel.description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localServiceComponentModel.description"
                          placeholder="未設定"
                          multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                      justify="center"
                      class="pa-10"
                      v-if="serviceProfilesLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>

              <div class="stepper-actions">
                <v-btn
                    color="primary"
                    @click="stepper = 2"
                    :disabled="!tradeContract.selfServiceProfileId">
                  次へ
                </v-btn>
              </div>
            </v-stepper-content>

            <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               Step 2 プロセス実装
             - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
            <v-stepper-step step="2" :complete="!!tradeContract.selfProcessProfileId">
              プロセス実装の選択
            </v-stepper-step>
            <div v-if="stepper > 2 && tradeContract.selfProcessProfileId" class="v-stepper__content process-profiles">
              <el-table
                  :data="selfProcessProfile ? [selfProcessProfile] : []"
                  row-key="id"
                  border>
                <el-table-column
                    label="名称"
                    width="200"
                    prop="localProcessComponentModel.name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localProcessComponentModel.name"
                          :value-local-id="row.processImplementation.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                    label="説明"
                    prop="localProcessComponentModel.description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localProcessComponentModel.description"
                          placeholder="未設定"
                          multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                      justify="center"
                      class="pa-10"
                      v-if="processProfilesLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>
            </div>
            <v-stepper-content step="2" class="process-profiles">
              <el-table
                  :data="processProfiles"
                  row-key="id"
                  border>
                <el-table-column
                    label="選択"
                    column-key="selected"
                    width="70"
                    align="center">
                  <template #default="{row}">
                    <table-inline>
                      <el-radio
                          :value="tradeContract.selfProcessProfileId === row.id"
                          @change="tradeContract.selfProcessProfileId = row.id"
                          :label="true"
                          class="no-label"
                          v-if="editable">
                      </el-radio>
                      <readonly-checkbox
                          :value="tradeContract.selfProcessProfileId === row.id"
                          v-else>
                      </readonly-checkbox>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                    label="名称"
                    width="200"
                    prop="localProcessComponentModel.name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localProcessComponentModel.name"
                          :value-local-id="row.processImplementation.localId">
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <el-table-column
                    label="説明"
                    prop="localProcessComponentModel.description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.localProcessComponentModel.description"
                          placeholder="未設定"
                          multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>

                <template #empty>
                  <v-row
                      justify="center"
                      class="pa-10"
                      v-if="processProfilesLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                </template>
              </el-table>

              <div class="stepper-actions">
                <v-btn
                    @click="stepper = 1">
                  戻る
                </v-btn>
                <v-btn
                    color="primary"
                    @click="stepper = 3"
                    :disabled="!tradeContract.selfProcessProfileId">
                  次へ
                </v-btn>
              </div>
            </v-stepper-content>

            <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               Step 3 イベント実装
             - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
            <v-stepper-step step="3" :complete="tradeContract.selfEventProfileIds.length > 0">
              イベント実装の選択
            </v-stepper-step>
            <v-stepper-content step="3" class="event-profiles">
              <el-table :data="eventProfiles" border>
                <el-table-column
                    label="選択"
                    column-key="selected"
                    width="70"
                    align="center">
                  <template #default="{row}">
                    <table-inline>
                      <el-checkbox
                          :value="row.selected"
                          @change="selectEventProfile(row, $event)"
                          v-if="editable">
                      </el-checkbox>
                      <readonly-checkbox
                          :value="row.selected"
                          v-else>
                      </readonly-checkbox>
                    </table-inline>
                  </template>
                </el-table-column>
                <el-table-column
                    label="名称"
                    width="200"
                    prop="localId">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.name"
                          :value-local-id="row.localId"
                          placeholder="未設定">
                        <template #prepend>
                          <el-tooltip v-if="row.eventProfileableType === 'EventImplementation' && tradeContract.isSelfProduce"
                                      content="トリガとなるイベント" :open-delay="500" placement="left">
                            <v-icon>mdi-lightning-bolt</v-icon>
                          </el-tooltip>
                          <el-tooltip v-else-if="row.eventProfileableType === 'EventImplementation' && tradeContract.isSelfConsume"
                                      content="イベント" :open-delay="500" placement="left">
                            <v-icon>mdi-lightning-bolt</v-icon>
                          </el-tooltip>
                          <el-tooltip v-else-if="row.eventProfileableType === 'CalendarImplementation'"
                                      content="カレンダ" :open-delay="500" placement="left">
                            <v-icon>mdi-calendar</v-icon>
                          </el-tooltip>
                        </template>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>
                <el-table-column
                    label="説明"
                    column-key="eventImplementation.description"
                    prop="description">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.description"
                          placeholder="未設定"
                          multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>
                <el-table-column
                    label="プロセス名"
                    width="200"
                    prop="processComponentModel.name">
                  <template #default="{row}">
                    <table-inline>
                      <text-field-like
                          :value="row.processComponentModel && row.processComponentModel.name"
                          :placeholder="row.processComponentModel ? '未設定' : '\u2E3B'"
                          multi-line>
                      </text-field-like>
                    </table-inline>
                  </template>
                </el-table-column>
                <template v-if="tradeContract.isSelfProduce">
                  <el-table-column
                      label="説明"
                      prop="processComponentModel.description">
                    <template #default="{row}">
                      <table-inline>
                        <text-field-like
                            :value="row.processComponentModel && row.processComponentModel.description"
                            :placeholder="row.processComponentModel ? '未設定' : '\u2E3B'"
                            multi-line>
                        </text-field-like>
                      </table-inline>
                    </template>
                  </el-table-column>
                </template>
                <template v-if="tradeContract.isSelfConsume">
                  <el-table-column
                      label="記録"
                      prop="is_monitored"
                      width="50"
                      align="center">
                    <template #default="{row}">
                      <table-inline>
                        <readonly-checkbox :value="row.isMonitored"></readonly-checkbox>
                      </table-inline>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="記録内容"
                      prop="monitoringContent">
                    <template #default="{row}">
                      <table-inline>
                        <text-field-like
                            :value="row.isMonitored ? row.monitoringContent : null"
                            :placeholder="row.isMonitored ? '未設定' : '\u2E3B'"
                            multi-line>
                        </text-field-like>
                      </table-inline>
                    </template>
                  </el-table-column>
                  <el-table-column
                      v-for="pot in processOperationTypes"
                      :key="pot.name"
                      :label="pot.label"
                      :prop="pot.prop"
                      width="50"
                      align="center">
                    <template #default="{row}">
                      <table-inline>
                        <readonly-checkbox :value="row[pot.prop]"></readonly-checkbox>
                      </table-inline>
                    </template>
                  </el-table-column>
                </template>
<!--                <el-table-column-->
<!--                    label="提供プロセス"-->
<!--                    width="150"-->
<!--                    column-key="processImplementation.name"-->
<!--                    prop="name"-->
<!--                    v-if="tradeContract.isSelfProduce">-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    label="記述内容"-->
<!--                    width="100"-->
<!--                    column-key="eventImplementation.monitoring_content"-->
<!--                    prop="monitoringContent"-->
<!--                    v-if="tradeContract.isSelfConsume">-->
<!--                </el-table-column>-->
                <template #empty>
                  <v-row
                      justify="center"
                      class="pa-10"
                      v-if="eventProfilesLoading">
                    <v-progress-circular indeterminate/>
                  </v-row>
                  <span v-else>
                    選択されたサービス実装・プロセス実装には適合するイベント実装がありませんでした。
                  </span>
                </template>
              </el-table>

              <div class="stepper-actions">
                <v-btn
                    @click="stepper = 2">
                  戻る
                </v-btn>
                <v-btn
                    color="primary"
                    @click="$emit('next-step')"
                    :disabled="!(tradeContract.isSelfProduce || tradeContract.selfEventProfileIds.length > 0)">
                  {{ nextPageName }}に進む
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-container>

    <app-header :errors="errors">
      <error-panel :errors="errors" small></error-panel>
      <v-spacer></v-spacer>
      <v-btn
          elevation="0"
          color="primary"
          style="align-self: center;"
          :disabled="!isCompletable"
          @click="$emit('next-step')">
        {{ nextPageName }}進む
      </v-btn>
    </app-header>
  </base-page-template>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import gql from "graphql-tag";
import Qs from "qs";
import BetterSet from "betterset";
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import TradeContractView, {emptyTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import ErrorIcon from "@/components/molecules/ErrorIcon.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {PROCESS_OPERATION_OPERATION_TYPES} from "@/constants";
import {capitalize} from "@/utils/StringUtil";
import scrollIntoView from "scroll-into-view-if-needed";
import ErrorPanel from "@/components/molecules/ErrorPanel.vue";
import AppHeader from "@/components/atoms/AppHeader.vue";
import {PropType} from "vue";

/**
 * 指定された配列を最大 count の長さ毎に切り分けます
 *
 * @param array 配列
 * @param count チャンクの長さ
 * @return 指定された長さで切り分けられた配列
 */
function chunkArray(array, count) {
  return array.reduce((result, current) => {
    const index = result.length - 1;
    if(index < 0 || result[index].length >= count) {
      result.push([current]);
    } else {
      result[index].push(current);
    }
    return result;
  }, []);
}

export default {
  name: "ServiceProfile",
  components: {
    AppHeader,
    ErrorPanel,
    TextFieldLike,
    ErrorIcon,
    ReadonlyCheckbox,
    TableInline,
    BasePageTemplate,
  },
  props: {
    tradeContracts: {
      type: Array,
      required: true
    },
    tradeContractIndex: {
      type: Number,
      default: 1
    },
    editable: {
      type: Boolean
    },
    steps: {
      type: Array,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      processImplementationCache: new Map(),
      processOperationTypes: ['read', 'update', 'delete'].map(t => ({
        name: t,
        prop: 'can' + capitalize(t),
        label: PROCESS_OPERATION_OPERATION_TYPES[t],
      })),

      stepper: 0,
      serviceProfiles: [],
      serviceProfilesSourceId: null,
      serviceProfilesLoading: false,
      processProfiles: [],
      processProfilesSourceId: null,
      processProfilesLoading: false,
      eventProfiles: [],
      eventProfilesSourceId: null,
      eventProfilesLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      hcsClient: 'hcs/client',
    }),
    tradeContract() {
      return this.tradeContracts[this.tradeContractIndex - 1] ?? emptyTradeContractView();
    },
    selfServiceProfile() {
      const selfServiceProfileId = this.tradeContract.selfServiceProfileId;
      if(selfServiceProfileId) {
        return this.serviceProfiles.find(sp => sp.id === selfServiceProfileId);
      } else {
        return null;
      }
    },
    selfProcessProfile() {
      const selfProcessProfileId = this.tradeContract.selfProcessProfileId;
      if(selfProcessProfileId) {
        return this.processProfiles.find(pp => pp.id === selfProcessProfileId);
      } else {
        return null;
      }
    },
    isCompletable() {
      return this.tradeContract.selfServiceProfileId &&
          this.tradeContract.selfProcessProfileId &&
          (this.tradeContract.isSelfProduce || this.tradeContract.selfEventProfileIds.length > 0);
    },
    errors() {
      const errors = [];
      if(!this.tradeContract.selfDataProfileId) {
        const routeBase = this.$route.name.replace(/^(\/[^/]+).*$/, '$1');
        errors.push({
          level: 'error',
          message: [
              'はじめにデータプロファイルを',
              this.$createElement('router-link', {
                props: {
                  to: {name: `${routeBase}/dataProfile`}
                }
              }, ['選択']),
              'して下さい。'
          ]
        });
      }
      switch(this.stepper) {
        case 1:
          if(this.tradeContract.selfServiceProfileId) {
            errors.push({
              level: 'good',
              message: 'サービス実装が選択されています。「次へ」を押すとプロセス実装の選択に移動します。'
            });
          } else {
            errors.push({
              level: 'info',
              message: 'サービス実装を選択してください。'
            });
          }
          break;
        case 2:
          if(this.tradeContract.selfProcessProfileId) {
            if(this.tradeContract.isSelfProduce) {
              errors.push({
                level: 'good',
                message: `プロセス実装が選択されています。「次へ」を押すとイベント実装の選択に移動します。このまま${this.nextPageName}に進む事も可能です。`
              });
            } else {
              errors.push({
                level: 'good',
                message: 'プロセス実装が選択されています。「次へ」を押すとイベント実装の選択に移動します。'
              });
            }
          } else {
            errors.push({
              level: 'info',
              message: 'プロセス実装を選択してください。'
            });
          }
          break;
        case 3:
          if(this.tradeContract.selfEventProfileIds.length > 0) {
            errors.push({
              level: 'good',
              message: `イベント実装が選択されています。${this.nextPageName}に進む事が可能です。`
            });
          } else if(this.tradeContract.isSelfProduce) {
            errors.push({
              level: 'info',
              message: `イベント実装を選択してください。このまま${this.nextPageName}に進む事も可能です。`
            });
          } else {
            errors.push({
              level: 'info',
              message: 'イベント実装を選択してください。'
            });
          }
          break;
      }
      return errors;
    },
    nextPageName() {
      return this.steps[this.step + 1]?.label ?? '契約内容';
    },
  },
  methods: {
    ...mapActions({
      gqlQuery: 'hds/gqlQuery',
    }),
    selectEventProfile(eventProfile, selected) {
      const newEventProfileIds = new BetterSet(this.tradeContract.selfEventProfileIds);
      const eventProfileId = eventProfile.id;
      eventProfile.selected = selected;
      if(selected) {
        newEventProfileIds.add(eventProfileId);
      } else {
        newEventProfileIds.delete(eventProfileId);
      }
      this.tradeContract.selfEventProfileIds = newEventProfileIds.asArray();
    },
    loadProcessImplementation(processImplementationId) {
      if(this.processImplementationCache.has(processImplementationId)) {
        return this.processImplementationCache.get(processImplementationId);
      }
      const promise = this.hcsClient.get(`/process_implementations/${processImplementationId}`).then(result => result.data);
      this.processImplementationCache.set(processImplementationId, promise);
      return promise;
    },
    /**
     * Step1
     *
     * @return {Promise<void>}
     */
    async loadServiceProfiles() {
      const selfDataProfileId = this.tradeContract.selfDataProfileId;
      if(!selfDataProfileId || this.serviceProfilesSourceId === selfDataProfileId) {
        return;
      }

      try {
        this.serviceProfilesLoading = true;
        this.serviceProfiles = [];

        const [
          {data: processOperationImplementations},
          {data: serviceProfiles},
        ] = await Promise.all([
          (async () => {
            const {data: dataProfile} = await this.hcsClient.get(`/data_profiles/${selfDataProfileId}`);
            return this.hcsClient.get('/process_operation_implementations', {
              params: {'q[data_implementation_id_eq]': dataProfile.dataImplementationId}
            });
          })(),
          this.hcsClient.get('/service_profiles', {
            params: {'q[service_type_eq]': this.tradeContract.serviceType}
          }),
        ]);

        const serviceProfileMap = new Map();
        const serviceComponentModelIds = new BetterSet();
        for (const processOperationImplementation of processOperationImplementations) {
          const processImplementation = await this.loadProcessImplementation(processOperationImplementation.processImplementationId);
          const serviceProfile = serviceProfiles.find(sp => sp.serviceImplementationId === processImplementation.serviceImplementationId && sp.serviceType === this.tradeContract.serviceType);
          serviceProfileMap.set(serviceProfile.id, serviceProfile);
          serviceComponentModelIds.add(serviceProfile.serviceComponentModelId);
          serviceComponentModelIds.add(serviceProfile.serviceImplementation.serviceComponentModelId);
        }

        const {serviceComponentModels} = await this.gqlQuery({
          query: gql`
              query FindServiceComponentModel(
                  $serviceComponentModelIds: [ID!]!,
              ) {
                  serviceComponentModels: serviceComponentModelInBulk(serviceComponentModelIds: $serviceComponentModelIds) {
                      id
                      name
                      description
                  }
              }`,
          variables: {
            serviceComponentModelIds: serviceComponentModelIds.asArray()
          }
        });

        this.serviceProfiles = Array.from(serviceProfileMap.values()).map(serviceProfile => {
          return {
            ...serviceProfile,
            commonServiceComponentModel: serviceComponentModels.find(scm => scm.id === serviceProfile.serviceComponentModelId),
            localServiceComponentModel: serviceComponentModels.find(scm => scm.id === serviceProfile.serviceImplementation.serviceComponentModelId),
          };
        });
        this.serviceProfilesSourceId = selfDataProfileId;
      } finally {
        this.serviceProfilesLoading = false;
      }
    },
    /**
     * Step2
     *
     * @return {Promise<void>}
     */
    async loadProcessProfiles() {
      const selfServiceProfileId = this.tradeContract.selfServiceProfileId;
      if(!selfServiceProfileId || this.processProfilesSourceId === selfServiceProfileId) {
        this.processProfilesLoading = false;
        return;
      }

      try {
        this.processProfilesLoading = true;
        this.processProfiles = [];

        const {data: processProfiles} = await this.hcsClient.get(`/process_profiles`, {
          params: {'q[service_profile_id_eq]': selfServiceProfileId}
        });

        const {data: dataProfile} = await this.hcsClient.get(`/data_profiles/${this.tradeContract.selfDataProfileId}`);
        const {data: processOperationImplementations} = await this.hcsClient.get('/process_operation_implementations', {
          params: {'q[data_implementation_id_eq]': dataProfile.dataImplementationId}
        });

        const result = [];
        const processComponentModelIds = new BetterSet();
        for (const processProfile of processProfiles) {
          const hasMatchedPoi = processOperationImplementations.some(poi => {
            if(poi.processImplementationId !== processProfile.processImplementationId) {
              return false;
            }
            return (
              (this.tradeContract.isSelfProduce && ['create'].includes(poi.operationType)) ||
              (this.tradeContract.isSelfConsume && ['read', 'update', 'delete'].includes(poi.operationType))
            );
          });
          if(!hasMatchedPoi) {
            continue;
          }

          const processImplementation = await this.loadProcessImplementation(processProfile.processImplementationId);
          processComponentModelIds.add(processImplementation.processComponentModelId);
          result.push({
            ...processProfile,
            processImplementation
          });
        }

        const {processComponentModels} = await this.gqlQuery({
          query: gql`
              query FindProcessComponentModel(
                  $processComponentModelIds: [ID!]!,
              ) {
                  processComponentModels: processComponentModelInBulk(processComponentModelIds: $processComponentModelIds) {
                      id
                      name
                      description
                  }
              }`,
          variables: {
            processComponentModelIds: processComponentModelIds.asArray()
          }
        });

        this.processProfiles = result.map(pp => {
          return {
            ...pp,
            localProcessComponentModel: processComponentModels.find(pcm => pcm.id === pp.processImplementation.processComponentModelId),
          }
        });
        this.processProfilesSourceId = selfServiceProfileId;
      } finally {
        this.processProfilesLoading = false;

        /**
         * 動的にコンテンツが変更されたときに v-stepper-content の高さが更新されない不具合の修正。
         * 450 ミリ秒後に、その時点での高さが再設定されてしまうので
         * 500 ミリ秒後に、高さをリセットします。
         *
         * @see https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VStepper/VStepperContent.ts#L129
         */
        setTimeout(() => {
          const swEl = this.$el.querySelector('.v-stepper__content.process-profiles > .v-stepper__wrapper');
          if(swEl) {
            swEl.style.height = 'auto';
          }
        }, 500);
      }
    },
    /**
     * Step 3
     *
     * @return {Promise<void>}
     */
    async loadEventProfiles() {
      const selfProcessProfileId = this.tradeContract.selfProcessProfileId;
      if(!selfProcessProfileId) {
        this.eventProfilesLoading = false;
        return;
      }

      // 進捗表示に必要なデータを取得
      const eventProfileExChunkSize = 30;

      try {
        this.eventProfilesLoading = true;
        this.eventProfiles = [];

        const {data: eventProfiles} = await this.hcsClient.get('/event_profiles');
        const eventProfileIdsChunk = chunkArray(eventProfiles.map(ep => ep.id), eventProfileExChunkSize);
        const eventProfileExtras = []; // 追加のイベントプロファイル情報
        for (const eventProfileIds of eventProfileIdsChunk) {
          const axiosGetConfig = {
            params: {
              q: {idIn: eventProfileIds}
            },
            paramsSerializer: function (params) {
              return Qs.stringify(params, {arrayFormat: 'brackets', skipNulls: true})
            }
          };
          let result;
          if (this.tradeContract.isSelfProduce) {
            ({data: result} = await this.hcsClient.get('/assets/producer_event_profiles', axiosGetConfig));
          } else if (this.tradeContract.isSelfConsume) {
            ({data: result} = await this.hcsClient.get('/assets/consumer_event_profiles', axiosGetConfig));
          } else {
            throw new Error(`Invalid service type: ${this.tradeContract.serviceType}`);
          }
          eventProfileExtras.push(...result);
        }

        this.eventProfiles = eventProfileExtras
            .map(epEx => {
              const ep = eventProfiles.find(ep => ep.id === epEx.id);
              if (ep) {
                return {
                  ...epEx, ...ep,
                  selected: this.tradeContract.selfEventProfileIds.includes(ep.id),
                };
              } else {
                return null;
              }
            })
            .filter(ep => ep !== null)
            .filter(ep => ep.processProfileId === selfProcessProfileId);
      } finally {
        this.eventProfilesLoading = false;

        /**
         * 動的にコンテンツが変更されたときに v-stepper-content の高さが更新されない不具合の修正。
         * 450 ミリ秒後に、その時点での高さが再設定されてしまうので
         * 500 ミリ秒後に、高さをリセットします。
         *
         * @see https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VStepper/VStepperContent.ts#L129
         */
        setTimeout(() => {
          const swEl = this.$el.querySelector('.v-stepper__content.event-profiles > .v-stepper__wrapper');
          if(swEl) {
            swEl.style.height = 'auto';
          }
        }, 500);
      }
    }
  },
  watch: {
    stepper: {
      immediate: false,
      async handler(stepper) {
        switch(stepper) {
          case 1:
            this.tradeContract.selfProcessProfileId = null;
            this.tradeContract.selfEventProfileIds = [];
            await this.loadServiceProfiles();
            return;
          case 2:
            this.serviceProfilesLoading = true;
            this.processProfilesLoading = true;
            this.tradeContract.selfEventProfileIds = [];
            await this.loadProcessProfiles();
            await this.loadServiceProfiles();
            this.$nextTick(() => {
              const el = this.$el.querySelector('.process-profiles');
              scrollIntoView(el, {
                scrollMode: 'if-needed',
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
                skipOverflowHiddenElements: true
              });
            });
            return;
          case 3:
            this.eventProfilesLoading = true;
            this.serviceProfilesLoading = true;
            this.processProfilesLoading = true;
            await this.loadEventProfiles();
            await this.loadServiceProfiles();
            await this.loadProcessProfiles();
            this.$nextTick(() => {
              const el = this.$el.querySelector('.event-profiles');
              scrollIntoView(el, {
                scrollMode: 'if-needed',
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
                skipOverflowHiddenElements: true
              });
            });
            return;
        }
      }
    },
    'tradeContract.selfEventProfileIds': {
      immediate: false,
      async handler(eventProfileIds) {
        this.eventProfiles.forEach(ep => {
          ep.selected = eventProfileIds.includes(ep.id);
        });
      }
    },
    'tradeContract': {
      immediate: true,
      async handler() {
        console.log('watch', this.tradeContract)
        if(this.tradeContract.selfEventProfileIds.length > 0) {
          const eventProfileIds = this.tradeContract.selfEventProfileIds;
          const eventProfileIdSet = new BetterSet(eventProfileIds);
          for(const eventProfileId of eventProfileIds) {
            if(this.eventProfiles.some(ep => ep.id === eventProfileId)) {
              break;
            }

            try {
              const {data: eventProfile} = await this.hcsClient.get(`/event_profiles/${eventProfileId}`);
            } catch (e) {
              eventProfileIdSet.delete(eventProfileId);
            }
          }
          if(eventProfileIds.length !== eventProfileIdSet.size) {
            this.tradeContract.selfEventProfileIds = eventProfileIdSet.asArray();
          }
        }

        if(this.tradeContract.selfEventProfileIds.length > 0) {
          this.stepper = 3;
        } else if(this.tradeContract.selfProcessProfileId) {
          this.stepper = 2;
        } else if(this.tradeContract.selfDataProfileId) {
          this.stepper = 1;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.multipane.layout-v > * {
  min-height: 500px;
}

.empty-service {
  margin-top: 1.5rem;
  font-size: 150%;
}

.empty-event {
  font-size: 150%;
  margin: 2rem -1000px 0;
  line-height: 2;
}

.stepper-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-start;
  padding: 3px;
  margin-left: -3px;

  & > * {
    margin-right: 1.5rem;
  }
}
</style>
